import type { KeyboardEvent, ReactNode } from "react";
import classNames from "classnames";
import { useNavigate } from "@/router";
import { getEventOverviewPath } from "../_utils/eventOverviewPath";

const ROW_BORDER = "border-t border-sys-brand-surface-container-highest";

type ClickableEventRowProps = {
  slug: string;
  title: string;
  children: ReactNode;
};

export default function ClickableEventRow({ slug, title, children }: ClickableEventRowProps) {
  const navigate = useNavigate();

  const openEvent = () => {
    navigate(getEventOverviewPath(slug));
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLTableRowElement>) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      openEvent();
    }
  };

  return (
    <tr
      className={classNames(
        ROW_BORDER,
        "cursor-pointer bg-sys-brand-surface hover:bg-sys-brand-surface-container-low focus-visible:outline focus-visible:outline-2 focus-visible:outline-sys-brand-primary"
      )}
      data-testid="body-row"
      onClick={openEvent}
      onKeyDown={handleKeyDown}
      tabIndex={0}
      role="link"
      aria-label={`Open event: ${title}`}
    >
      {children}
    </tr>
  );
}

export { ROW_BORDER };
